import React from 'react';
import { BoxStyled } from './box.styled';

interface BoxProps {
  bg?: string;
  sx?: object;
  m?: number;
  mt?: number;
  mr?: number;
  ml?: number;
  mb?: number;
  mx?: number;
  my?: number;
  p?: number;
  pt?: number;
  pr?: number;
  pl?: number;
  pb?: number;
  px?: number;
  py?: number;
  children?: React.ReactNode | React.ReactNode[];
}

const Box = ({ children, ...rest }: BoxProps) => {
  return <BoxStyled {...rest}>{children}</BoxStyled>;
};

export default Box;
